// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Additional Utility Classes and Component Styles */

/* ==========================================================================
   Layout Utilities
   ========================================================================== */

/* Container Variations */
.container-fluid {
  width: 100%;
  padding: 0 var(--spacing-4);
}

.container-narrow {
  max-width: 600px;
  margin: 0 auto;
  padding: 0 var(--spacing-4);
}

.container-wide {
  max-width: 1600px;
  margin: 0 auto;
  padding: 0 var(--spacing-4);
}

/* Section Spacing */
.section {
  padding: var(--spacing-20) 0;
}

.section-sm {
  padding: var(--spacing-12) 0;
}

.section-lg {
  padding: var(--spacing-32) 0;
}

.section-xl {
  padding: var(--spacing-40) 0;
}

/* ==========================================================================
   Typography Utilities
   ========================================================================== */

/* Text Sizes (Extended) */
.text-4xl { font-size: var(--font-size-4xl); }
.text-5xl { font-size: var(--font-size-5xl); }
.text-6xl { font-size: var(--font-size-6xl); }
.text-7xl { font-size: var(--font-size-7xl); }
.text-8xl { font-size: var(--font-size-8xl); }
.text-9xl { font-size: var(--font-size-9xl); }

/* Font Weights (Extended) */
.font-thin { font-weight: var(--font-weight-thin); }
.font-extralight { font-weight: var(--font-weight-extralight); }
.font-extrabold { font-weight: var(--font-weight-extrabold); }
.font-black { font-weight: var(--font-weight-black); }

/* Line Heights */
.leading-none { line-height: var(--line-height-none); }
.leading-tight { line-height: var(--line-height-tight); }
.leading-snug { line-height: var(--line-height-snug); }
.leading-normal { line-height: var(--line-height-normal); }
.leading-relaxed { line-height: var(--line-height-relaxed); }
.leading-loose { line-height: var(--line-height-loose); }

/* Letter Spacing */
.tracking-tighter { letter-spacing: var(--letter-spacing-tighter); }
.tracking-tight { letter-spacing: var(--letter-spacing-tight); }
.tracking-normal { letter-spacing: var(--letter-spacing-normal); }
.tracking-wide { letter-spacing: var(--letter-spacing-wide); }
.tracking-wider { letter-spacing: var(--letter-spacing-wider); }
.tracking-widest { letter-spacing: var(--letter-spacing-widest); }

/* Text Colors (Extended) */
.text-success { color: var(--color-success); }
.text-warning { color: var(--color-warning); }
.text-error { color: var(--color-error); }
.text-info { color: var(--color-info); }
.text-white { color: white; }
.text-black { color: black; }

/* Text Utilities */
.text-uppercase { text-transform: uppercase; }
.text-lowercase { text-transform: lowercase; }
.text-capitalize { text-transform: capitalize; }
.text-truncate {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.text-ellipsis {
  overflow: hidden;
  text-overflow: ellipsis;
}

.text-clip {
  text-overflow: clip;
}

/* ==========================================================================
   Spacing Utilities (Extended)
   ========================================================================== */

/* Margin Utilities */
.m-1 { margin: var(--spacing-1); }
.m-2 { margin: var(--spacing-2); }
.m-3 { margin: var(--spacing-3); }
.m-4 { margin: var(--spacing-4); }
.m-5 { margin: var(--spacing-5); }
.m-6 { margin: var(--spacing-6); }
.m-8 { margin: var(--spacing-8); }
.m-10 { margin: var(--spacing-10); }
.m-12 { margin: var(--spacing-12); }
.m-16 { margin: var(--spacing-16); }
.m-20 { margin: var(--spacing-20); }
.m-24 { margin: var(--spacing-24); }
.m-32 { margin: var(--spacing-32); }

/* Margin X-axis */
.mx-1 { margin-left: var(--spacing-1); margin-right: var(--spacing-1); }
.mx-2 { margin-left: var(--spacing-2); margin-right: var(--spacing-2); }
.mx-3 { margin-left: var(--spacing-3); margin-right: var(--spacing-3); }
.mx-4 { margin-left: var(--spacing-4); margin-right: var(--spacing-4); }
.mx-6 { margin-left: var(--spacing-6); margin-right: var(--spacing-6); }
.mx-8 { margin-left: var(--spacing-8); margin-right: var(--spacing-8); }

/* Margin Y-axis */
.my-1 { margin-top: var(--spacing-1); margin-bottom: var(--spacing-1); }
.my-2 { margin-top: var(--spacing-2); margin-bottom: var(--spacing-2); }
.my-3 { margin-top: var(--spacing-3); margin-bottom: var(--spacing-3); }
.my-4 { margin-top: var(--spacing-4); margin-bottom: var(--spacing-4); }
.my-6 { margin-top: var(--spacing-6); margin-bottom: var(--spacing-6); }
.my-8 { margin-top: var(--spacing-8); margin-bottom: var(--spacing-8); }
.my-12 { margin-top: var(--spacing-12); margin-bottom: var(--spacing-12); }
.my-16 { margin-top: var(--spacing-16); margin-bottom: var(--spacing-16); }
.my-20 { margin-top: var(--spacing-20); margin-bottom: var(--spacing-20); }

/* Margin Top */
.mt-1 { margin-top: var(--spacing-1); }
.mt-2 { margin-top: var(--spacing-2); }
.mt-3 { margin-top: var(--spacing-3); }
.mt-4 { margin-top: var(--spacing-4); }
.mt-6 { margin-top: var(--spacing-6); }
.mt-8 { margin-top: var(--spacing-8); }
.mt-12 { margin-top: var(--spacing-12); }
.mt-16 { margin-top: var(--spacing-16); }
.mt-20 { margin-top: var(--spacing-20); }

/* Margin Bottom */
.mb-1 { margin-bottom: var(--spacing-1); }
.mb-2 { margin-bottom: var(--spacing-2); }
.mb-3 { margin-bottom: var(--spacing-3); }
.mb-4 { margin-bottom: var(--spacing-4); }
.mb-6 { margin-bottom: var(--spacing-6); }
.mb-8 { margin-bottom: var(--spacing-8); }
.mb-12 { margin-bottom: var(--spacing-12); }
.mb-16 { margin-bottom: var(--spacing-16); }
.mb-20 { margin-bottom: var(--spacing-20); }

/* Padding Utilities (Extended) */
.p-1 { padding: var(--spacing-1); }
.p-2 { padding: var(--spacing-2); }
.p-3 { padding: var(--spacing-3); }
.p-5 { padding: var(--spacing-5); }
.p-10 { padding: var(--spacing-10); }
.p-12 { padding: var(--spacing-12); }
.p-16 { padding: var(--spacing-16); }
.p-20 { padding: var(--spacing-20); }
.p-24 { padding: var(--spacing-24); }

/* Padding X-axis */
.px-1 { padding-left: var(--spacing-1); padding-right: var(--spacing-1); }
.px-2 { padding-left: var(--spacing-2); padding-right: var(--spacing-2); }
.px-3 { padding-left: var(--spacing-3); padding-right: var(--spacing-3); }
.px-5 { padding-left: var(--spacing-5); padding-right: var(--spacing-5); }
.px-6 { padding-left: var(--spacing-6); padding-right: var(--spacing-6); }
.px-8 { padding-left: var(--spacing-8); padding-right: var(--spacing-8); }
.px-12 { padding-left: var(--spacing-12); padding-right: var(--spacing-12); }

/* Padding Y-axis */
.py-1 { padding-top: var(--spacing-1); padding-bottom: var(--spacing-1); }
.py-2 { padding-top: var(--spacing-2); padding-bottom: var(--spacing-2); }
.py-3 { padding-top: var(--spacing-3); padding-bottom: var(--spacing-3); }
.py-5 { padding-top: var(--spacing-5); padding-bottom: var(--spacing-5); }
.py-6 { padding-top: var(--spacing-6); padding-bottom: var(--spacing-6); }
.py-8 { padding-top: var(--spacing-8); padding-bottom: var(--spacing-8); }
.py-12 { padding-top: var(--spacing-12); padding-bottom: var(--spacing-12); }
.py-16 { padding-top: var(--spacing-16); padding-bottom: var(--spacing-16); }
.py-20 { padding-top: var(--spacing-20); padding-bottom: var(--spacing-20); }

/* ==========================================================================
   Background and Border Utilities
   ========================================================================== */

/* Background Colors */
.bg-primary { background-color: var(--color-primary); }
.bg-secondary { background-color: var(--color-secondary); }
.bg-success { background-color: var(--color-success); }
.bg-warning { background-color: var(--color-warning); }
.bg-error { background-color: var(--color-error); }
.bg-info { background-color: var(--color-info); }
.bg-surface { background-color: var(--color-surface); }
.bg-surface-elevated { background-color: var(--color-surface-elevated); }
.bg-white { background-color: white; }
.bg-black { background-color: black; }
.bg-transparent { background-color: transparent; }

/* Background Gradients */
.bg-gradient-primary {
  background: linear-gradient(135deg, var(--color-primary) 0%, var(--color-primary-light) 100%);
}

.bg-gradient-secondary {
  background: linear-gradient(135deg, var(--color-secondary) 0%, var(--color-secondary-light) 100%);
}

.bg-gradient-to-r {
  background: linear-gradient(to right, var(--color-primary), var(--color-secondary));
}

.bg-gradient-to-b {
  background: linear-gradient(to bottom, var(--color-primary), var(--color-primary-dark));
}

/* Border Utilities */
.border { border: var(--border-width-1) solid var(--color-border); }
.border-2 { border: var(--border-width-2) solid var(--color-border); }
.border-4 { border: var(--border-width-4) solid var(--color-border); }
.border-0 { border: 0; }

.border-t { border-top: var(--border-width-1) solid var(--color-border); }
.border-r { border-right: var(--border-width-1) solid var(--color-border); }
.border-b { border-bottom: var(--border-width-1) solid var(--color-border); }
.border-l { border-left: var(--border-width-1) solid var(--color-border); }

/* Border Colors */
.border-primary { border-color: var(--color-primary); }
.border-secondary { border-color: var(--color-secondary); }
.border-success { border-color: var(--color-success); }
.border-warning { border-color: var(--color-warning); }
.border-error { border-color: var(--color-error); }
.border-transparent { border-color: transparent; }

/* Border Radius (Extended) */
.rounded-none { border-radius: var(--radius-none); }
.rounded-sm { border-radius: var(--radius-sm); }
.rounded-2xl { border-radius: var(--radius-2xl); }
.rounded-3xl { border-radius: var(--radius-3xl); }

.rounded-t { border-top-left-radius: var(--radius-base); border-top-right-radius: var(--radius-base); }
.rounded-r { border-top-right-radius: var(--radius-base); border-bottom-right-radius: var(--radius-base); }
.rounded-b { border-bottom-left-radius: var(--radius-base); border-bottom-right-radius: var(--radius-base); }
.rounded-l { border-top-left-radius: var(--radius-base); border-bottom-left-radius: var(--radius-base); }

/* ==========================================================================
   Flexbox and Grid Utilities (Extended)
   ========================================================================== */

/* Flex Grow/Shrink */
.flex-grow { flex-grow: 1; }
.flex-grow-0 { flex-grow: 0; }
.flex-shrink { flex-shrink: 1; }
.flex-shrink-0 { flex-shrink: 0; }

/* Align Self */
.self-auto { align-self: auto; }
.self-start { align-self: flex-start; }
.self-center { align-self: center; }
.self-end { align-self: flex-end; }
.self-stretch { align-self: stretch; }

/* Order */
.order-1 { order: 1; }
.order-2 { order: 2; }
.order-3 { order: 3; }
.order-first { order: -9999; }
.order-last { order: 9999; }
.order-none { order: 0; }

/* Grid Utilities (Extended) */
.grid-cols-5 { grid-template-columns: repeat(5, minmax(0, 1fr)); }
.grid-cols-7 { grid-template-columns: repeat(7, minmax(0, 1fr)); }
.grid-cols-8 { grid-template-columns: repeat(8, minmax(0, 1fr)); }
.grid-cols-9 { grid-template-columns: repeat(9, minmax(0, 1fr)); }
.grid-cols-10 { grid-template-columns: repeat(10, minmax(0, 1fr)); }
.grid-cols-11 { grid-template-columns: repeat(11, minmax(0, 1fr)); }

/* Grid Column Span */
.col-span-1 { grid-column: span 1 / span 1; }
.col-span-2 { grid-column: span 2 / span 2; }
.col-span-3 { grid-column: span 3 / span 3; }
.col-span-4 { grid-column: span 4 / span 4; }
.col-span-5 { grid-column: span 5 / span 5; }
.col-span-6 { grid-column: span 6 / span 6; }
.col-span-full { grid-column: 1 / -1; }

/* Grid Row Span */
.row-span-1 { grid-row: span 1 / span 1; }
.row-span-2 { grid-row: span 2 / span 2; }
.row-span-3 { grid-row: span 3 / span 3; }
.row-span-4 { grid-row: span 4 / span 4; }
.row-span-full { grid-row: 1 / -1; }

/* Gap Utilities (Extended) */
.gap-0 { gap: 0; }
.gap-0-5 { gap: var(--spacing-0-5); }
.gap-1-5 { gap: var(--spacing-1-5); }
.gap-5 { gap: var(--spacing-5); }
.gap-10 { gap: var(--spacing-10); }
.gap-12 { gap: var(--spacing-12); }
.gap-16 { gap: var(--spacing-16); }
.gap-20 { gap: var(--spacing-20); }

.gap-x-1 { column-gap: var(--spacing-1); }
.gap-x-2 { column-gap: var(--spacing-2); }
.gap-x-4 { column-gap: var(--spacing-4); }
.gap-x-6 { column-gap: var(--spacing-6); }
.gap-x-8 { column-gap: var(--spacing-8); }

.gap-y-1 { row-gap: var(--spacing-1); }
.gap-y-2 { row-gap: var(--spacing-2); }
.gap-y-4 { row-gap: var(--spacing-4); }
.gap-y-6 { row-gap: var(--spacing-6); }
.gap-y-8 { row-gap: var(--spacing-8); }

/* ==========================================================================
   Width and Height Utilities
   ========================================================================== */

/* Width */
.w-auto { width: auto; }
.w-full { width: 100%; }
.w-screen { width: 100vw; }
.w-min { width: min-content; }
.w-max { width: max-content; }
.w-fit { width: fit-content; }

.w-1\\/2 { width: 50%; }
.w-1\\/3 { width: 33.333333%; }
.w-2\\/3 { width: 66.666667%; }
.w-1\\/4 { width: 25%; }
.w-3\\/4 { width: 75%; }
.w-1\\/5 { width: 20%; }
.w-2\\/5 { width: 40%; }
.w-3\\/5 { width: 60%; }
.w-4\\/5 { width: 80%; }

/* Height */
.h-auto { height: auto; }
.h-full { height: 100%; }
.h-screen { height: 100vh; }
.h-min { height: min-content; }
.h-max { height: max-content; }
.h-fit { height: fit-content; }

.h-1\\/2 { height: 50%; }
.h-1\\/3 { height: 33.333333%; }
.h-2\\/3 { height: 66.666667%; }
.h-1\\/4 { height: 25%; }
.h-3\\/4 { height: 75%; }

/* Min/Max Width */
.min-w-0 { min-width: 0px; }
.min-w-full { min-width: 100%; }
.min-w-min { min-width: min-content; }
.min-w-max { min-width: max-content; }

.max-w-none { max-width: none; }
.max-w-xs { max-width: 20rem; }
.max-w-sm { max-width: 24rem; }
.max-w-md { max-width: 28rem; }
.max-w-lg { max-width: 32rem; }
.max-w-xl { max-width: 36rem; }
.max-w-2xl { max-width: 42rem; }
.max-w-3xl { max-width: 48rem; }
.max-w-4xl { max-width: 56rem; }
.max-w-5xl { max-width: 64rem; }
.max-w-6xl { max-width: 72rem; }
.max-w-7xl { max-width: 80rem; }
.max-w-full { max-width: 100%; }
.max-w-screen-sm { max-width: var(--breakpoint-sm); }
.max-w-screen-md { max-width: var(--breakpoint-md); }
.max-w-screen-lg { max-width: var(--breakpoint-lg); }
.max-w-screen-xl { max-width: var(--breakpoint-xl); }

/* Min/Max Height */
.min-h-0 { min-height: 0px; }
.min-h-full { min-height: 100%; }
.min-h-screen { min-height: 100vh; }

.max-h-full { max-height: 100%; }
.max-h-screen { max-height: 100vh; }

/* ==========================================================================
   Animation and Transform Utilities
   ========================================================================== */

/* Transform */
.transform { transform: translateX(var(--tw-translate-x, 0)) translateY(var(--tw-translate-y, 0)) rotate(var(--tw-rotate, 0)) skewX(var(--tw-skew-x, 0)) skewY(var(--tw-skew-y, 0)) scaleX(var(--tw-scale-x, 1)) scaleY(var(--tw-scale-y, 1)); }
.transform-none { transform: none; }

/* Scale */
.scale-0 { transform: scale(0); }
.scale-50 { transform: scale(0.5); }
.scale-75 { transform: scale(0.75); }
.scale-90 { transform: scale(0.9); }
.scale-95 { transform: scale(0.95); }
.scale-100 { transform: scale(1); }
.scale-105 { transform: scale(1.05); }
.scale-110 { transform: scale(1.1); }
.scale-125 { transform: scale(1.25); }
.scale-150 { transform: scale(1.5); }

/* Rotate */
.rotate-0 { transform: rotate(0deg); }
.rotate-1 { transform: rotate(1deg); }
.rotate-2 { transform: rotate(2deg); }
.rotate-3 { transform: rotate(3deg); }
.rotate-6 { transform: rotate(6deg); }
.rotate-12 { transform: rotate(12deg); }
.rotate-45 { transform: rotate(45deg); }
.rotate-90 { transform: rotate(90deg); }
.rotate-180 { transform: rotate(180deg); }

/* Translate */
.translate-x-0 { transform: translateX(0px); }
.translate-x-1 { transform: translateX(var(--spacing-1)); }
.translate-x-2 { transform: translateX(var(--spacing-2)); }
.translate-x-4 { transform: translateX(var(--spacing-4)); }
.translate-x-8 { transform: translateX(var(--spacing-8)); }

.translate-y-0 { transform: translateY(0px); }
.translate-y-1 { transform: translateY(var(--spacing-1)); }
.translate-y-2 { transform: translateY(var(--spacing-2)); }
.translate-y-4 { transform: translateY(var(--spacing-4)); }
.translate-y-8 { transform: translateY(var(--spacing-8)); }

/* Animation Classes */
.animate-spin {
  animation: spin 1s linear infinite;
}

.animate-ping {
  animation: ping 1s cubic-bezier(0, 0, 0.2, 1) infinite;
}

.animate-pulse {
  animation: pulse 2s cubic-bezier(0.4, 0, 0.6, 1) infinite;
}

.animate-bounce {
  animation: bounce 1s infinite;
}

.animate-fade-in {
  animation: fadeIn 0.5s ease-in-out;
}

.animate-slide-in-up {
  animation: slideInUp 0.5s ease-out;
}

.animate-slide-in-down {
  animation: slideInDown 0.5s ease-out;
}

.animate-slide-in-left {
  animation: slideInLeft 0.5s ease-out;
}

.animate-slide-in-right {
  animation: slideInRight 0.5s ease-out;
}

@keyframes ping {
  75%, 100% {
    transform: scale(2);
    opacity: 0;
  }
}

@keyframes pulse {
  0%, 100% {
    opacity: 1;
  }
  50% {
    opacity: .5;
  }
}

@keyframes bounce {
  0%, 100% {
    transform: translateY(-25%);
    animation-timing-function: cubic-bezier(0.8, 0, 1, 1);
  }
  50% {
    transform: translateY(0);
    animation-timing-function: cubic-bezier(0, 0, 0.2, 1);
  }
}

@keyframes fadeIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

@keyframes slideInUp {
  from {
    transform: translateY(100%);
    opacity: 0;
  }
  to {
    transform: translateY(0);
    opacity: 1;
  }
}

@keyframes slideInDown {
  from {
    transform: translateY(-100%);
    opacity: 0;
  }
  to {
    transform: translateY(0);
    opacity: 1;
  }
}

@keyframes slideInLeft {
  from {
    transform: translateX(-100%);
    opacity: 0;
  }
  to {
    transform: translateX(0);
    opacity: 1;
  }
}

@keyframes slideInRight {
  from {
    transform: translateX(100%);
    opacity: 0;
  }
  to {
    transform: translateX(0);
    opacity: 1;
  }
}

/* ==========================================================================
   Component-Specific Styles
   ========================================================================== */

/* Hero Section */
.hero {
  background: linear-gradient(135deg, var(--color-primary) 0%, var(--color-primary-light) 100%);
  color: white;
  padding: var(--spacing-32) 0 var(--spacing-20);
  margin-top: 70px; /* Account for fixed navigation */
  text-align: center;
  position: relative;
  overflow: hidden;
}

.hero::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.1);
  z-index: 1;
}

.hero-actions {
  display: flex;
  gap: var(--spacing-4);
  justify-content: center;
  flex-wrap: wrap;
}

/* Stats Section */
.stats-section {
  padding: var(--spacing-20) 0;
  background-color: var(--color-surface);
}

.stats-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  gap: var(--spacing-8);
  text-align: center;
}

.stat-item {
  padding: var(--spacing-6);
  background: var(--color-surface-elevated);
  border-radius: var(--radius-xl);
  box-shadow: var(--shadow-sm);
  transition: all var(--transition-base);
}

.stat-item:hover {
  transform: translateY(-4px);
  box-shadow: var(--shadow-md);
}

.stat-value {
  font-size: var(--font-size-4xl);
  font-weight: var(--font-weight-extrabold);
  color: var(--color-primary);
  margin-bottom: var(--spacing-2);
  line-height: var(--line-height-none);
}

.stat-label {
  font-size: var(--font-size-lg);
  color: var(--color-text-secondary);
  font-weight: var(--font-weight-medium);
  text-transform: uppercase;
  letter-spacing: var(--letter-spacing-wide);
}

/* Courses Overview */
.courses-overview {
  padding: var(--spacing-20) 0;
}

.section-title {
  text-align: center;
  font-size: var(--font-size-4xl);
  margin-bottom: var(--spacing-12);
  color: var(--color-text);
  font-weight: var(--font-weight-extrabold);
}

.courses-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  gap: var(--spacing-8);
}

/* Footer */
.footer {
  background-color: var(--color-primary);
  color: white;
  padding: var(--spacing-16) 0 var(--spacing-8);
}

.footer-content {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: var(--spacing-8);
  margin-bottom: var(--spacing-8);
}

.footer-section h3,
.footer-section h4 {
  margin-bottom: var(--spacing-4);
  color: white;
  font-weight: var(--font-weight-bold);
}

.footer-section ul {
  list-style: none;
  padding: 0;
}

.footer-section ul li {
  margin-bottom: var(--spacing-2);
}

.footer-section ul li a {
  color: rgba(255, 255, 255, 0.8);
  text-decoration: none;
  transition: color var(--transition-fast);
}

.footer-section ul li a:hover {
  color: white;
  text-decoration: underline;
}

.footer-bottom {
  text-align: center;
  padding-top: var(--spacing-8);
  border-top: 1px solid rgba(255, 255, 255, 0.2);
  color: rgba(255, 255, 255, 0.8);
}

/* Loading Overlay */
.loading-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  backdrop-filter: blur(4px);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: var(--z-modal);
}

.loading-spinner {
  width: 40px;
  height: 40px;
  border: 4px solid var(--color-border);
  border-top: 4px solid var(--color-primary);
  border-radius: 50%;
  animation: spin 1s linear infinite;
}

/* Toast Notifications */
.toast {
  position: fixed;
  top: var(--spacing-4);
  right: var(--spacing-4);
  background-color: var(--color-surface-elevated);
  color: var(--color-text);
  padding: var(--spacing-4) var(--spacing-6);
  border-radius: var(--radius-lg);
  box-shadow: var(--shadow-lg);
  border: 1px solid var(--color-border);
  z-index: var(--z-toast);
  animation: slideInRight 0.3s ease-out;
  max-width: 400px;
  min-width: 300px;
}

.toast.success {
  border-left: 4px solid var(--color-success);
}

.toast.error {
  border-left: 4px solid var(--color-error);
}

.toast.warning {
  border-left: 4px solid var(--color-warning);
}

.toast.info {
  border-left: 4px solid var(--color-info);
}

/* Form Styles */
.form-group {
  margin-bottom: var(--spacing-4);
}

.form-label {
  display: block;
  margin-bottom: var(--spacing-2);
  font-weight: var(--font-weight-medium);
  color: var(--color-text);
}

.form-input {
  width: 100%;
  padding: var(--spacing-3) var(--spacing-4);
  border: 1px solid var(--color-border);
  border-radius: var(--radius-md);
  background-color: var(--color-surface);
  color: var(--color-text);
  font-size: var(--font-size-base);
  transition: all var(--transition-fast);
}

.form-input:focus {
  outline: none;
  border-color: var(--color-primary);
  box-shadow: 0 0 0 3px rgba(var(--color-primary-rgb), 0.1);
}

.form-input.error {
  border-color: var(--color-error);
}

.form-input.success {
  border-color: var(--color-success);
}

.form-error {
  color: var(--color-error);
  font-size: var(--font-size-sm);
  margin-top: var(--spacing-1);
  display: flex;
  align-items: center;
  gap: var(--spacing-1);
}

.form-success {
  color: var(--color-success);
  font-size: var(--font-size-sm);
  margin-top: var(--spacing-1);
  display: flex;
  align-items: center;
  gap: var(--spacing-1);
}

/* Button Sizes */
.btn-xs {
  padding: var(--spacing-1) var(--spacing-2);
  font-size: var(--font-size-xs);
}

.btn-sm {
  padding: var(--spacing-2) var(--spacing-4);
  font-size: var(--font-size-sm);
}

.btn-lg {
  padding: var(--spacing-4) var(--spacing-8);
  font-size: var(--font-size-lg);
}

.btn-xl {
  padding: var(--spacing-5) var(--spacing-10);
  font-size: var(--font-size-xl);
}

/* Card Component */
.card {
  background-color: var(--color-surface);
  border: 1px solid var(--color-border);
  border-radius: var(--radius-lg);
  box-shadow: var(--shadow-sm);
  overflow: hidden;
  transition: all var(--transition-base);
}

.card:hover {
  box-shadow: var(--shadow-md);
  transform: translateY(-2px);
}

.card-header {
  padding: var(--spacing-6);
  border-bottom: 1px solid var(--color-border);
  background-color: var(--color-surface-elevated);
}

.card-body {
  padding: var(--spacing-6);
}

.card-footer {
  padding: var(--spacing-6);
  border-top: 1px solid var(--color-border);
  background-color: var(--color-surface-elevated);
}

/* Badge Component */
.badge {
  display: inline-flex;
  align-items: center;
  padding: var(--spacing-1) var(--spacing-2);
  font-size: var(--font-size-xs);
  font-weight: var(--font-weight-medium);
  border-radius: var(--radius-full);
  text-transform: uppercase;
  letter-spacing: var(--letter-spacing-wide);
}

.badge-primary {
  background-color: var(--color-primary);
  color: white;
}

.badge-secondary {
  background-color: var(--color-secondary);
  color: white;
}

.badge-success {
  background-color: var(--color-success);
  color: white;
}

.badge-warning {
  background-color: var(--color-warning);
  color: white;
}

.badge-error {
  background-color: var(--color-error);
  color: white;
}

.badge-outline {
  background-color: transparent;
  border: 1px solid var(--color-border);
  color: var(--color-text);
}

/* ==========================================================================
   Responsive Design Utilities
   ========================================================================== */

/* Mobile First Responsive Utilities */
@media (min-width: 475px) {
  .xs\\:block { display: block; }
  .xs\\:hidden { display: none; }
  .xs\\:flex { display: flex; }
  .xs\\:grid { display: grid; }
  .xs\\:text-center { text-align: center; }
  .xs\\:text-left { text-align: left; }
}

@media (min-width: 640px) {
  .sm\\:block { display: block; }
  .sm\\:hidden { display: none; }
  .sm\\:flex { display: flex; }
  .sm\\:grid { display: grid; }
  .sm\\:grid-cols-2 { grid-template-columns: repeat(2, minmax(0, 1fr)); }
  .sm\\:grid-cols-3 { grid-template-columns: repeat(3, minmax(0, 1fr)); }
  .sm\\:flex-row { flex-direction: row; }
  .sm\\:flex-col { flex-direction: column; }
  .sm\\:text-left { text-align: left; }
  .sm\\:text-center { text-align: center; }
  .sm\\:text-right { text-align: right; }
  .sm\\:p-6 { padding: var(--spacing-6); }
  .sm\\:px-6 { padding-left: var(--spacing-6); padding-right: var(--spacing-6); }
  .sm\\:py-8 { padding-top: var(--spacing-8); padding-bottom: var(--spacing-8); }
}

@media (min-width: 768px) {
  .md\\:block { display: block; }
  .md\\:hidden { display: none; }
  .md\\:flex { display: flex; }
  .md\\:grid { display: grid; }
  .md\\:grid-cols-2 { grid-template-columns: repeat(2, minmax(0, 1fr)); }
  .md\\:grid-cols-3 { grid-template-columns: repeat(3, minmax(0, 1fr)); }
  .md\\:grid-cols-4 { grid-template-columns: repeat(4, minmax(0, 1fr)); }
  .md\\:flex-row { flex-direction: row; }
  .md\\:flex-col { flex-direction: column; }
  .md\\:text-left { text-align: left; }
  .md\\:text-center { text-align: center; }
  .md\\:text-right { text-align: right; }
  .md\\:text-lg { font-size: var(--font-size-lg); }
  .md\\:text-xl { font-size: var(--font-size-xl); }
  .md\\:text-2xl { font-size: var(--font-size-2xl); }
  .md\\:text-3xl { font-size: var(--font-size-3xl); }
  .md\\:p-8 { padding: var(--spacing-8); }
  .md\\:px-8 { padding-left: var(--spacing-8); padding-right: var(--spacing-8); }
  .md\\:py-12 { padding-top: var(--spacing-12); padding-bottom: var(--spacing-12); }
}

@media (min-width: 1024px) {
  .lg\\:block { display: block; }
  .lg\\:hidden { display: none; }
  .lg\\:flex { display: flex; }
  .lg\\:grid { display: grid; }
  .lg\\:grid-cols-3 { grid-template-columns: repeat(3, minmax(0, 1fr)); }
  .lg\\:grid-cols-4 { grid-template-columns: repeat(4, minmax(0, 1fr)); }
  .lg\\:grid-cols-5 { grid-template-columns: repeat(5, minmax(0, 1fr)); }
  .lg\\:grid-cols-6 { grid-template-columns: repeat(6, minmax(0, 1fr)); }
  .lg\\:flex-row { flex-direction: row; }
  .lg\\:flex-col { flex-direction: column; }
  .lg\\:text-left { text-align: left; }
  .lg\\:text-center { text-align: center; }
  .lg\\:text-right { text-align: right; }
  .lg\\:text-xl { font-size: var(--font-size-xl); }
  .lg\\:text-2xl { font-size: var(--font-size-2xl); }
  .lg\\:text-3xl { font-size: var(--font-size-3xl); }
  .lg\\:text-4xl { font-size: var(--font-size-4xl); }
  .lg\\:p-12 { padding: var(--spacing-12); }
  .lg\\:px-12 { padding-left: var(--spacing-12); padding-right: var(--spacing-12); }
  .lg\\:py-16 { padding-top: var(--spacing-16); padding-bottom: var(--spacing-16); }
}

@media (min-width: 1280px) {
  .xl\\:block { display: block; }
  .xl\\:hidden { display: none; }
  .xl\\:grid-cols-4 { grid-template-columns: repeat(4, minmax(0, 1fr)); }
  .xl\\:grid-cols-5 { grid-template-columns: repeat(5, minmax(0, 1fr)); }
  .xl\\:grid-cols-6 { grid-template-columns: repeat(6, minmax(0, 1fr)); }
  .xl\\:text-2xl { font-size: var(--font-size-2xl); }
  .xl\\:text-3xl { font-size: var(--font-size-3xl); }
  .xl\\:text-4xl { font-size: var(--font-size-4xl); }
  .xl\\:text-5xl { font-size: var(--font-size-5xl); }
}

@media (min-width: 1536px) {
  .2xl\\:block { display: block; }
  .2xl\\:hidden { display: none; }
  .2xl\\:grid-cols-5 { grid-template-columns: repeat(5, minmax(0, 1fr)); }
  .2xl\\:grid-cols-6 { grid-template-columns: repeat(6, minmax(0, 1fr)); }
  .2xl\\:text-3xl { font-size: var(--font-size-3xl); }
  .2xl\\:text-4xl { font-size: var(--font-size-4xl); }
  .2xl\\:text-5xl { font-size: var(--font-size-5xl); }
  .2xl\\:text-6xl { font-size: var(--font-size-6xl); }
}

/* ==========================================================================
   Mobile Responsive Adjustments
   ========================================================================== */

@media (max-width: 768px) {
  .hero {
    padding: var(--spacing-20) 0 var(--spacing-16);
  }
  
  .hero-title {
    font-size: var(--font-size-3xl);
  }
  
  .hero-subtitle {
    font-size: var(--font-size-lg);
  }
  
  .hero-actions {
    flex-direction: column;
    align-items: center;
  }
  
  .stats-grid {
    grid-template-columns: repeat(2, 1fr);
    gap: var(--spacing-4);
  }
  
  .courses-grid {
    grid-template-columns: 1fr;
  }
  
  .section-title {
    font-size: var(--font-size-3xl);
  }
  
  .toast {
    left: var(--spacing-4);
    right: var(--spacing-4);
    max-width: none;
  }
}

@media (max-width: 480px) {
  .stats-grid {
    grid-template-columns: 1fr;
  }
  
  .stat-value {
    font-size: var(--font-size-3xl);
  }
  
  .hero-title {
    font-size: var(--font-size-2xl);
  }
  
  .section-title {
    font-size: var(--font-size-2xl);
  }
  

}

/* ==========================================================================
   Print Styles
   ========================================================================== */

@media print {
  .no-print {
    display: none !important;
  }
  
  .hero,
  .navigation,
  .footer,
  .toast,
  .loading-overlay {
    display: none !important;
  }
  
  * {
    background: white !important;
    color: black !important;
    box-shadow: none !important;
  }
  
  a {
    text-decoration: underline !important;
  }
  
  .container {
    max-width: none !important;
    padding: 0 !important;
  }
}
`, "",{"version":3,"sources":["webpack://./src/frontend/styles/utilities.css"],"names":[],"mappings":"AAAA,oDAAoD;;AAEpD;;+EAE+E;;AAE/E,yBAAyB;AACzB;EACE,WAAW;EACX,2BAA2B;AAC7B;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,2BAA2B;AAC7B;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,2BAA2B;AAC7B;;AAEA,oBAAoB;AACpB;EACE,4BAA4B;AAC9B;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;;+EAE+E;;AAE/E,0BAA0B;AAC1B,YAAY,+BAA+B,EAAE;AAC7C,YAAY,+BAA+B,EAAE;AAC7C,YAAY,+BAA+B,EAAE;AAC7C,YAAY,+BAA+B,EAAE;AAC7C,YAAY,+BAA+B,EAAE;AAC7C,YAAY,+BAA+B,EAAE;;AAE7C,4BAA4B;AAC5B,aAAa,oCAAoC,EAAE;AACnD,mBAAmB,0CAA0C,EAAE;AAC/D,kBAAkB,yCAAyC,EAAE;AAC7D,cAAc,qCAAqC,EAAE;;AAErD,iBAAiB;AACjB,gBAAgB,oCAAoC,EAAE;AACtD,iBAAiB,qCAAqC,EAAE;AACxD,gBAAgB,oCAAoC,EAAE;AACtD,kBAAkB,sCAAsC,EAAE;AAC1D,mBAAmB,uCAAuC,EAAE;AAC5D,iBAAiB,qCAAqC,EAAE;;AAExD,mBAAmB;AACnB,oBAAoB,6CAA6C,EAAE;AACnE,kBAAkB,2CAA2C,EAAE;AAC/D,mBAAmB,4CAA4C,EAAE;AACjE,iBAAiB,0CAA0C,EAAE;AAC7D,kBAAkB,2CAA2C,EAAE;AAC/D,mBAAmB,4CAA4C,EAAE;;AAEjE,2BAA2B;AAC3B,gBAAgB,2BAA2B,EAAE;AAC7C,gBAAgB,2BAA2B,EAAE;AAC7C,cAAc,yBAAyB,EAAE;AACzC,aAAa,wBAAwB,EAAE;AACvC,cAAc,YAAY,EAAE;AAC5B,cAAc,YAAY,EAAE;;AAE5B,mBAAmB;AACnB,kBAAkB,yBAAyB,EAAE;AAC7C,kBAAkB,yBAAyB,EAAE;AAC7C,mBAAmB,0BAA0B,EAAE;AAC/C;EACE,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;;+EAE+E;;AAE/E,qBAAqB;AACrB,OAAO,wBAAwB,EAAE;AACjC,OAAO,wBAAwB,EAAE;AACjC,OAAO,wBAAwB,EAAE;AACjC,OAAO,wBAAwB,EAAE;AACjC,OAAO,wBAAwB,EAAE;AACjC,OAAO,wBAAwB,EAAE;AACjC,OAAO,wBAAwB,EAAE;AACjC,QAAQ,yBAAyB,EAAE;AACnC,QAAQ,yBAAyB,EAAE;AACnC,QAAQ,yBAAyB,EAAE;AACnC,QAAQ,yBAAyB,EAAE;AACnC,QAAQ,yBAAyB,EAAE;AACnC,QAAQ,yBAAyB,EAAE;;AAEnC,kBAAkB;AAClB,QAAQ,6BAA6B,EAAE,8BAA8B,EAAE;AACvE,QAAQ,6BAA6B,EAAE,8BAA8B,EAAE;AACvE,QAAQ,6BAA6B,EAAE,8BAA8B,EAAE;AACvE,QAAQ,6BAA6B,EAAE,8BAA8B,EAAE;AACvE,QAAQ,6BAA6B,EAAE,8BAA8B,EAAE;AACvE,QAAQ,6BAA6B,EAAE,8BAA8B,EAAE;;AAEvE,kBAAkB;AAClB,QAAQ,4BAA4B,EAAE,+BAA+B,EAAE;AACvE,QAAQ,4BAA4B,EAAE,+BAA+B,EAAE;AACvE,QAAQ,4BAA4B,EAAE,+BAA+B,EAAE;AACvE,QAAQ,4BAA4B,EAAE,+BAA+B,EAAE;AACvE,QAAQ,4BAA4B,EAAE,+BAA+B,EAAE;AACvE,QAAQ,4BAA4B,EAAE,+BAA+B,EAAE;AACvE,SAAS,6BAA6B,EAAE,gCAAgC,EAAE;AAC1E,SAAS,6BAA6B,EAAE,gCAAgC,EAAE;AAC1E,SAAS,6BAA6B,EAAE,gCAAgC,EAAE;;AAE1E,eAAe;AACf,QAAQ,4BAA4B,EAAE;AACtC,QAAQ,4BAA4B,EAAE;AACtC,QAAQ,4BAA4B,EAAE;AACtC,QAAQ,4BAA4B,EAAE;AACtC,QAAQ,4BAA4B,EAAE;AACtC,QAAQ,4BAA4B,EAAE;AACtC,SAAS,6BAA6B,EAAE;AACxC,SAAS,6BAA6B,EAAE;AACxC,SAAS,6BAA6B,EAAE;;AAExC,kBAAkB;AAClB,QAAQ,+BAA+B,EAAE;AACzC,QAAQ,+BAA+B,EAAE;AACzC,QAAQ,+BAA+B,EAAE;AACzC,QAAQ,+BAA+B,EAAE;AACzC,QAAQ,+BAA+B,EAAE;AACzC,QAAQ,+BAA+B,EAAE;AACzC,SAAS,gCAAgC,EAAE;AAC3C,SAAS,gCAAgC,EAAE;AAC3C,SAAS,gCAAgC,EAAE;;AAE3C,iCAAiC;AACjC,OAAO,yBAAyB,EAAE;AAClC,OAAO,yBAAyB,EAAE;AAClC,OAAO,yBAAyB,EAAE;AAClC,OAAO,yBAAyB,EAAE;AAClC,QAAQ,0BAA0B,EAAE;AACpC,QAAQ,0BAA0B,EAAE;AACpC,QAAQ,0BAA0B,EAAE;AACpC,QAAQ,0BAA0B,EAAE;AACpC,QAAQ,0BAA0B,EAAE;;AAEpC,mBAAmB;AACnB,QAAQ,8BAA8B,EAAE,+BAA+B,EAAE;AACzE,QAAQ,8BAA8B,EAAE,+BAA+B,EAAE;AACzE,QAAQ,8BAA8B,EAAE,+BAA+B,EAAE;AACzE,QAAQ,8BAA8B,EAAE,+BAA+B,EAAE;AACzE,QAAQ,8BAA8B,EAAE,+BAA+B,EAAE;AACzE,QAAQ,8BAA8B,EAAE,+BAA+B,EAAE;AACzE,SAAS,+BAA+B,EAAE,gCAAgC,EAAE;;AAE5E,mBAAmB;AACnB,QAAQ,6BAA6B,EAAE,gCAAgC,EAAE;AACzE,QAAQ,6BAA6B,EAAE,gCAAgC,EAAE;AACzE,QAAQ,6BAA6B,EAAE,gCAAgC,EAAE;AACzE,QAAQ,6BAA6B,EAAE,gCAAgC,EAAE;AACzE,QAAQ,6BAA6B,EAAE,gCAAgC,EAAE;AACzE,QAAQ,6BAA6B,EAAE,gCAAgC,EAAE;AACzE,SAAS,8BAA8B,EAAE,iCAAiC,EAAE;AAC5E,SAAS,8BAA8B,EAAE,iCAAiC,EAAE;AAC5E,SAAS,8BAA8B,EAAE,iCAAiC,EAAE;;AAE5E;;+EAE+E;;AAE/E,sBAAsB;AACtB,cAAc,sCAAsC,EAAE;AACtD,gBAAgB,wCAAwC,EAAE;AAC1D,cAAc,sCAAsC,EAAE;AACtD,cAAc,sCAAsC,EAAE;AACtD,YAAY,oCAAoC,EAAE;AAClD,WAAW,mCAAmC,EAAE;AAChD,cAAc,sCAAsC,EAAE;AACtD,uBAAuB,+CAA+C,EAAE;AACxE,YAAY,uBAAuB,EAAE;AACrC,YAAY,uBAAuB,EAAE;AACrC,kBAAkB,6BAA6B,EAAE;;AAEjD,yBAAyB;AACzB;EACE,6FAA6F;AAC/F;;AAEA;EACE,iGAAiG;AACnG;;AAEA;EACE,mFAAmF;AACrF;;AAEA;EACE,uFAAuF;AACzF;;AAEA,qBAAqB;AACrB,UAAU,uDAAuD,EAAE;AACnE,YAAY,uDAAuD,EAAE;AACrE,YAAY,uDAAuD,EAAE;AACrE,YAAY,SAAS,EAAE;;AAEvB,YAAY,2DAA2D,EAAE;AACzE,YAAY,6DAA6D,EAAE;AAC3E,YAAY,8DAA8D,EAAE;AAC5E,YAAY,4DAA4D,EAAE;;AAE1E,kBAAkB;AAClB,kBAAkB,kCAAkC,EAAE;AACtD,oBAAoB,oCAAoC,EAAE;AAC1D,kBAAkB,kCAAkC,EAAE;AACtD,kBAAkB,kCAAkC,EAAE;AACtD,gBAAgB,gCAAgC,EAAE;AAClD,sBAAsB,yBAAyB,EAAE;;AAEjD,6BAA6B;AAC7B,gBAAgB,iCAAiC,EAAE;AACnD,cAAc,+BAA+B,EAAE;AAC/C,eAAe,gCAAgC,EAAE;AACjD,eAAe,gCAAgC,EAAE;;AAEjD,aAAa,0CAA0C,EAAE,2CAA2C,EAAE;AACtG,aAAa,2CAA2C,EAAE,8CAA8C,EAAE;AAC1G,aAAa,6CAA6C,EAAE,8CAA8C,EAAE;AAC5G,aAAa,0CAA0C,EAAE,6CAA6C,EAAE;;AAExG;;+EAE+E;;AAE/E,qBAAqB;AACrB,aAAa,YAAY,EAAE;AAC3B,eAAe,YAAY,EAAE;AAC7B,eAAe,cAAc,EAAE;AAC/B,iBAAiB,cAAc,EAAE;;AAEjC,eAAe;AACf,aAAa,gBAAgB,EAAE;AAC/B,cAAc,sBAAsB,EAAE;AACtC,eAAe,kBAAkB,EAAE;AACnC,YAAY,oBAAoB,EAAE;AAClC,gBAAgB,mBAAmB,EAAE;;AAErC,UAAU;AACV,WAAW,QAAQ,EAAE;AACrB,WAAW,QAAQ,EAAE;AACrB,WAAW,QAAQ,EAAE;AACrB,eAAe,YAAY,EAAE;AAC7B,cAAc,WAAW,EAAE;AAC3B,cAAc,QAAQ,EAAE;;AAExB,8BAA8B;AAC9B,eAAe,gDAAgD,EAAE;AACjE,eAAe,gDAAgD,EAAE;AACjE,eAAe,gDAAgD,EAAE;AACjE,eAAe,gDAAgD,EAAE;AACjE,gBAAgB,iDAAiD,EAAE;AACnE,gBAAgB,iDAAiD,EAAE;;AAEnE,qBAAqB;AACrB,cAAc,4BAA4B,EAAE;AAC5C,cAAc,4BAA4B,EAAE;AAC5C,cAAc,4BAA4B,EAAE;AAC5C,cAAc,4BAA4B,EAAE;AAC5C,cAAc,4BAA4B,EAAE;AAC5C,cAAc,4BAA4B,EAAE;AAC5C,iBAAiB,mBAAmB,EAAE;;AAEtC,kBAAkB;AAClB,cAAc,yBAAyB,EAAE;AACzC,cAAc,yBAAyB,EAAE;AACzC,cAAc,yBAAyB,EAAE;AACzC,cAAc,yBAAyB,EAAE;AACzC,iBAAiB,gBAAgB,EAAE;;AAEnC,6BAA6B;AAC7B,SAAS,MAAM,EAAE;AACjB,WAAW,uBAAuB,EAAE;AACpC,WAAW,uBAAuB,EAAE;AACpC,SAAS,qBAAqB,EAAE;AAChC,UAAU,sBAAsB,EAAE;AAClC,UAAU,sBAAsB,EAAE;AAClC,UAAU,sBAAsB,EAAE;AAClC,UAAU,sBAAsB,EAAE;;AAElC,WAAW,4BAA4B,EAAE;AACzC,WAAW,4BAA4B,EAAE;AACzC,WAAW,4BAA4B,EAAE;AACzC,WAAW,4BAA4B,EAAE;AACzC,WAAW,4BAA4B,EAAE;;AAEzC,WAAW,yBAAyB,EAAE;AACtC,WAAW,yBAAyB,EAAE;AACtC,WAAW,yBAAyB,EAAE;AACtC,WAAW,yBAAyB,EAAE;AACtC,WAAW,yBAAyB,EAAE;;AAEtC;;+EAE+E;;AAE/E,UAAU;AACV,UAAU,WAAW,EAAE;AACvB,UAAU,WAAW,EAAE;AACvB,YAAY,YAAY,EAAE;AAC1B,SAAS,kBAAkB,EAAE;AAC7B,SAAS,kBAAkB,EAAE;AAC7B,SAAS,kBAAkB,EAAE;;AAE7B,UAAU,UAAU,EAAE;AACtB,UAAU,iBAAiB,EAAE;AAC7B,UAAU,iBAAiB,EAAE;AAC7B,UAAU,UAAU,EAAE;AACtB,UAAU,UAAU,EAAE;AACtB,UAAU,UAAU,EAAE;AACtB,UAAU,UAAU,EAAE;AACtB,UAAU,UAAU,EAAE;AACtB,UAAU,UAAU,EAAE;;AAEtB,WAAW;AACX,UAAU,YAAY,EAAE;AACxB,UAAU,YAAY,EAAE;AACxB,YAAY,aAAa,EAAE;AAC3B,SAAS,mBAAmB,EAAE;AAC9B,SAAS,mBAAmB,EAAE;AAC9B,SAAS,mBAAmB,EAAE;;AAE9B,UAAU,WAAW,EAAE;AACvB,UAAU,kBAAkB,EAAE;AAC9B,UAAU,kBAAkB,EAAE;AAC9B,UAAU,WAAW,EAAE;AACvB,UAAU,WAAW,EAAE;;AAEvB,kBAAkB;AAClB,WAAW,cAAc,EAAE;AAC3B,cAAc,eAAe,EAAE;AAC/B,aAAa,sBAAsB,EAAE;AACrC,aAAa,sBAAsB,EAAE;;AAErC,cAAc,eAAe,EAAE;AAC/B,YAAY,gBAAgB,EAAE;AAC9B,YAAY,gBAAgB,EAAE;AAC9B,YAAY,gBAAgB,EAAE;AAC9B,YAAY,gBAAgB,EAAE;AAC9B,YAAY,gBAAgB,EAAE;AAC9B,aAAa,gBAAgB,EAAE;AAC/B,aAAa,gBAAgB,EAAE;AAC/B,aAAa,gBAAgB,EAAE;AAC/B,aAAa,gBAAgB,EAAE;AAC/B,aAAa,gBAAgB,EAAE;AAC/B,aAAa,gBAAgB,EAAE;AAC/B,cAAc,eAAe,EAAE;AAC/B,mBAAmB,+BAA+B,EAAE;AACpD,mBAAmB,+BAA+B,EAAE;AACpD,mBAAmB,+BAA+B,EAAE;AACpD,mBAAmB,+BAA+B,EAAE;;AAEpD,mBAAmB;AACnB,WAAW,eAAe,EAAE;AAC5B,cAAc,gBAAgB,EAAE;AAChC,gBAAgB,iBAAiB,EAAE;;AAEnC,cAAc,gBAAgB,EAAE;AAChC,gBAAgB,iBAAiB,EAAE;;AAEnC;;+EAE+E;;AAE/E,cAAc;AACd,aAAa,gOAAgO,EAAE;AAC/O,kBAAkB,eAAe,EAAE;;AAEnC,UAAU;AACV,WAAW,mBAAmB,EAAE;AAChC,YAAY,qBAAqB,EAAE;AACnC,YAAY,sBAAsB,EAAE;AACpC,YAAY,qBAAqB,EAAE;AACnC,YAAY,sBAAsB,EAAE;AACpC,aAAa,mBAAmB,EAAE;AAClC,aAAa,sBAAsB,EAAE;AACrC,aAAa,qBAAqB,EAAE;AACpC,aAAa,sBAAsB,EAAE;AACrC,aAAa,qBAAqB,EAAE;;AAEpC,WAAW;AACX,YAAY,uBAAuB,EAAE;AACrC,YAAY,uBAAuB,EAAE;AACrC,YAAY,uBAAuB,EAAE;AACrC,YAAY,uBAAuB,EAAE;AACrC,YAAY,uBAAuB,EAAE;AACrC,aAAa,wBAAwB,EAAE;AACvC,aAAa,wBAAwB,EAAE;AACvC,aAAa,wBAAwB,EAAE;AACvC,cAAc,yBAAyB,EAAE;;AAEzC,cAAc;AACd,iBAAiB,0BAA0B,EAAE;AAC7C,iBAAiB,uCAAuC,EAAE;AAC1D,iBAAiB,uCAAuC,EAAE;AAC1D,iBAAiB,uCAAuC,EAAE;AAC1D,iBAAiB,uCAAuC,EAAE;;AAE1D,iBAAiB,0BAA0B,EAAE;AAC7C,iBAAiB,uCAAuC,EAAE;AAC1D,iBAAiB,uCAAuC,EAAE;AAC1D,iBAAiB,uCAAuC,EAAE;AAC1D,iBAAiB,uCAAuC,EAAE;;AAE1D,sBAAsB;AACtB;EACE,kCAAkC;AACpC;;AAEA;EACE,sDAAsD;AACxD;;AAEA;EACE,yDAAyD;AAC3D;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE;IACE,mBAAmB;IACnB,UAAU;EACZ;AACF;;AAEA;EACE;IACE,UAAU;EACZ;EACA;IACE,WAAW;EACb;AACF;;AAEA;EACE;IACE,2BAA2B;IAC3B,qDAAqD;EACvD;EACA;IACE,wBAAwB;IACxB,qDAAqD;EACvD;AACF;;AAEA;EACE;IACE,UAAU;EACZ;EACA;IACE,UAAU;EACZ;AACF;;AAEA;EACE;IACE,2BAA2B;IAC3B,UAAU;EACZ;EACA;IACE,wBAAwB;IACxB,UAAU;EACZ;AACF;;AAEA;EACE;IACE,4BAA4B;IAC5B,UAAU;EACZ;EACA;IACE,wBAAwB;IACxB,UAAU;EACZ;AACF;;AAEA;EACE;IACE,4BAA4B;IAC5B,UAAU;EACZ;EACA;IACE,wBAAwB;IACxB,UAAU;EACZ;AACF;;AAEA;EACE;IACE,2BAA2B;IAC3B,UAAU;EACZ;EACA;IACE,wBAAwB;IACxB,UAAU;EACZ;AACF;;AAEA;;+EAE+E;;AAE/E,iBAAiB;AACjB;EACE,6FAA6F;EAC7F,YAAY;EACZ,8CAA8C;EAC9C,gBAAgB,EAAE,iCAAiC;EACnD,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,8BAA8B;EAC9B,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,uBAAuB;EACvB,eAAe;AACjB;;AAEA,kBAAkB;AAClB;EACE,4BAA4B;EAC5B,sCAAsC;AACxC;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,qBAAqB;EACrB,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,yCAAyC;EACzC,+BAA+B;EAC/B,4BAA4B;EAC5B,sCAAsC;AACxC;;AAEA;EACE,2BAA2B;EAC3B,4BAA4B;AAC9B;;AAEA;EACE,+BAA+B;EAC/B,yCAAyC;EACzC,2BAA2B;EAC3B,+BAA+B;EAC/B,oCAAoC;AACtC;;AAEA;EACE,8BAA8B;EAC9B,kCAAkC;EAClC,sCAAsC;EACtC,yBAAyB;EACzB,0CAA0C;AAC5C;;AAEA,qBAAqB;AACrB;EACE,4BAA4B;AAC9B;;AAEA;EACE,kBAAkB;EAClB,+BAA+B;EAC/B,gCAAgC;EAChC,wBAAwB;EACxB,yCAAyC;AAC3C;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,qBAAqB;AACvB;;AAEA,WAAW;AACX;EACE,sCAAsC;EACtC,YAAY;EACZ,6CAA6C;AAC/C;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,qBAAqB;EACrB,+BAA+B;AACjC;;AAEA;;EAEE,+BAA+B;EAC/B,YAAY;EACZ,oCAAoC;AACtC;;AAEA;EACE,gBAAgB;EAChB,UAAU;AACZ;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,+BAA+B;EAC/B,qBAAqB;EACrB,wCAAwC;AAC1C;;AAEA;EACE,YAAY;EACZ,0BAA0B;AAC5B;;AAEA;EACE,kBAAkB;EAClB,6BAA6B;EAC7B,8CAA8C;EAC9C,+BAA+B;AACjC;;AAEA,oBAAoB;AACpB;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,oCAAoC;EACpC,0BAA0B;EAC1B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,uBAAuB;AACzB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,qCAAqC;EACrC,0CAA0C;EAC1C,kBAAkB;EAClB,kCAAkC;AACpC;;AAEA,wBAAwB;AACxB;EACE,eAAe;EACf,qBAAqB;EACrB,uBAAuB;EACvB,+CAA+C;EAC/C,wBAAwB;EACxB,0CAA0C;EAC1C,+BAA+B;EAC/B,4BAA4B;EAC5B,qCAAqC;EACrC,uBAAuB;EACvB,qCAAqC;EACrC,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,2CAA2C;AAC7C;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;EACE,2CAA2C;AAC7C;;AAEA;EACE,wCAAwC;AAC1C;;AAEA,gBAAgB;AAChB;EACE,+BAA+B;AACjC;;AAEA;EACE,cAAc;EACd,+BAA+B;EAC/B,sCAAsC;EACtC,wBAAwB;AAC1B;;AAEA;EACE,WAAW;EACX,0CAA0C;EAC1C,qCAAqC;EACrC,+BAA+B;EAC/B,sCAAsC;EACtC,wBAAwB;EACxB,gCAAgC;EAChC,sCAAsC;AACxC;;AAEA;EACE,aAAa;EACb,kCAAkC;EAClC,yDAAyD;AAC3D;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,yBAAyB;EACzB,8BAA8B;EAC9B,4BAA4B;EAC5B,aAAa;EACb,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,2BAA2B;EAC3B,8BAA8B;EAC9B,4BAA4B;EAC5B,aAAa;EACb,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA,iBAAiB;AACjB;EACE,0CAA0C;EAC1C,8BAA8B;AAChC;;AAEA;EACE,0CAA0C;EAC1C,8BAA8B;AAChC;;AAEA;EACE,0CAA0C;EAC1C,8BAA8B;AAChC;;AAEA;EACE,2CAA2C;EAC3C,8BAA8B;AAChC;;AAEA,mBAAmB;AACnB;EACE,sCAAsC;EACtC,qCAAqC;EACrC,+BAA+B;EAC/B,4BAA4B;EAC5B,gBAAgB;EAChB,sCAAsC;AACxC;;AAEA;EACE,4BAA4B;EAC5B,2BAA2B;AAC7B;;AAEA;EACE,yBAAyB;EACzB,4CAA4C;EAC5C,+CAA+C;AACjD;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,yCAAyC;EACzC,+CAA+C;AACjD;;AAEA,oBAAoB;AACpB;EACE,oBAAoB;EACpB,mBAAmB;EACnB,0CAA0C;EAC1C,8BAA8B;EAC9B,sCAAsC;EACtC,iCAAiC;EACjC,yBAAyB;EACzB,0CAA0C;AAC5C;;AAEA;EACE,sCAAsC;EACtC,YAAY;AACd;;AAEA;EACE,wCAAwC;EACxC,YAAY;AACd;;AAEA;EACE,sCAAsC;EACtC,YAAY;AACd;;AAEA;EACE,sCAAsC;EACtC,YAAY;AACd;;AAEA;EACE,oCAAoC;EACpC,YAAY;AACd;;AAEA;EACE,6BAA6B;EAC7B,qCAAqC;EACrC,wBAAwB;AAC1B;;AAEA;;+EAE+E;;AAE/E,sCAAsC;AACtC;EACE,aAAa,cAAc,EAAE;EAC7B,cAAc,aAAa,EAAE;EAC7B,YAAY,aAAa,EAAE;EAC3B,YAAY,aAAa,EAAE;EAC3B,mBAAmB,kBAAkB,EAAE;EACvC,iBAAiB,gBAAgB,EAAE;AACrC;;AAEA;EACE,aAAa,cAAc,EAAE;EAC7B,cAAc,aAAa,EAAE;EAC7B,YAAY,aAAa,EAAE;EAC3B,YAAY,aAAa,EAAE;EAC3B,mBAAmB,gDAAgD,EAAE;EACrE,mBAAmB,gDAAgD,EAAE;EACrE,gBAAgB,mBAAmB,EAAE;EACrC,gBAAgB,sBAAsB,EAAE;EACxC,iBAAiB,gBAAgB,EAAE;EACnC,mBAAmB,kBAAkB,EAAE;EACvC,kBAAkB,iBAAiB,EAAE;EACrC,WAAW,yBAAyB,EAAE;EACtC,YAAY,8BAA8B,EAAE,+BAA+B,EAAE;EAC7E,YAAY,6BAA6B,EAAE,gCAAgC,EAAE;AAC/E;;AAEA;EACE,aAAa,cAAc,EAAE;EAC7B,cAAc,aAAa,EAAE;EAC7B,YAAY,aAAa,EAAE;EAC3B,YAAY,aAAa,EAAE;EAC3B,mBAAmB,gDAAgD,EAAE;EACrE,mBAAmB,gDAAgD,EAAE;EACrE,mBAAmB,gDAAgD,EAAE;EACrE,gBAAgB,mBAAmB,EAAE;EACrC,gBAAgB,sBAAsB,EAAE;EACxC,iBAAiB,gBAAgB,EAAE;EACnC,mBAAmB,kBAAkB,EAAE;EACvC,kBAAkB,iBAAiB,EAAE;EACrC,eAAe,8BAA8B,EAAE;EAC/C,eAAe,8BAA8B,EAAE;EAC/C,gBAAgB,+BAA+B,EAAE;EACjD,gBAAgB,+BAA+B,EAAE;EACjD,WAAW,yBAAyB,EAAE;EACtC,YAAY,8BAA8B,EAAE,+BAA+B,EAAE;EAC7E,aAAa,8BAA8B,EAAE,iCAAiC,EAAE;AAClF;;AAEA;EACE,aAAa,cAAc,EAAE;EAC7B,cAAc,aAAa,EAAE;EAC7B,YAAY,aAAa,EAAE;EAC3B,YAAY,aAAa,EAAE;EAC3B,mBAAmB,gDAAgD,EAAE;EACrE,mBAAmB,gDAAgD,EAAE;EACrE,mBAAmB,gDAAgD,EAAE;EACrE,mBAAmB,gDAAgD,EAAE;EACrE,gBAAgB,mBAAmB,EAAE;EACrC,gBAAgB,sBAAsB,EAAE;EACxC,iBAAiB,gBAAgB,EAAE;EACnC,mBAAmB,kBAAkB,EAAE;EACvC,kBAAkB,iBAAiB,EAAE;EACrC,eAAe,8BAA8B,EAAE;EAC/C,gBAAgB,+BAA+B,EAAE;EACjD,gBAAgB,+BAA+B,EAAE;EACjD,gBAAgB,+BAA+B,EAAE;EACjD,YAAY,0BAA0B,EAAE;EACxC,aAAa,+BAA+B,EAAE,gCAAgC,EAAE;EAChF,aAAa,8BAA8B,EAAE,iCAAiC,EAAE;AAClF;;AAEA;EACE,aAAa,cAAc,EAAE;EAC7B,cAAc,aAAa,EAAE;EAC7B,mBAAmB,gDAAgD,EAAE;EACrE,mBAAmB,gDAAgD,EAAE;EACrE,mBAAmB,gDAAgD,EAAE;EACrE,gBAAgB,+BAA+B,EAAE;EACjD,gBAAgB,+BAA+B,EAAE;EACjD,gBAAgB,+BAA+B,EAAE;EACjD,gBAAgB,+BAA+B,EAAE;AACnD;;AAEA;EACE,cAAc,cAAc,EAAE;EAC9B,eAAe,aAAa,EAAE;EAC9B,oBAAoB,gDAAgD,EAAE;EACtE,oBAAoB,gDAAgD,EAAE;EACtE,iBAAiB,+BAA+B,EAAE;EAClD,iBAAiB,+BAA+B,EAAE;EAClD,iBAAiB,+BAA+B,EAAE;EAClD,iBAAiB,+BAA+B,EAAE;AACpD;;AAEA;;+EAE+E;;AAE/E;EACE;IACE,8CAA8C;EAChD;;EAEA;IACE,+BAA+B;EACjC;;EAEA;IACE,8BAA8B;EAChC;;EAEA;IACE,sBAAsB;IACtB,mBAAmB;EACrB;;EAEA;IACE,qCAAqC;IACrC,qBAAqB;EACvB;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,+BAA+B;EACjC;;EAEA;IACE,sBAAsB;IACtB,uBAAuB;IACvB,eAAe;EACjB;AACF;;AAEA;EACE;IACE,0BAA0B;EAC5B;;EAEA;IACE,+BAA+B;EACjC;;EAEA;IACE,+BAA+B;EACjC;;EAEA;IACE,+BAA+B;EACjC;;;AAGF;;AAEA;;+EAE+E;;AAE/E;EACE;IACE,wBAAwB;EAC1B;;EAEA;;;;;IAKE,wBAAwB;EAC1B;;EAEA;IACE,4BAA4B;IAC5B,uBAAuB;IACvB,2BAA2B;EAC7B;;EAEA;IACE,qCAAqC;EACvC;;EAEA;IACE,0BAA0B;IAC1B,qBAAqB;EACvB;AACF","sourcesContent":["/* Additional Utility Classes and Component Styles */\n\n/* ==========================================================================\n   Layout Utilities\n   ========================================================================== */\n\n/* Container Variations */\n.container-fluid {\n  width: 100%;\n  padding: 0 var(--spacing-4);\n}\n\n.container-narrow {\n  max-width: 600px;\n  margin: 0 auto;\n  padding: 0 var(--spacing-4);\n}\n\n.container-wide {\n  max-width: 1600px;\n  margin: 0 auto;\n  padding: 0 var(--spacing-4);\n}\n\n/* Section Spacing */\n.section {\n  padding: var(--spacing-20) 0;\n}\n\n.section-sm {\n  padding: var(--spacing-12) 0;\n}\n\n.section-lg {\n  padding: var(--spacing-32) 0;\n}\n\n.section-xl {\n  padding: var(--spacing-40) 0;\n}\n\n/* ==========================================================================\n   Typography Utilities\n   ========================================================================== */\n\n/* Text Sizes (Extended) */\n.text-4xl { font-size: var(--font-size-4xl); }\n.text-5xl { font-size: var(--font-size-5xl); }\n.text-6xl { font-size: var(--font-size-6xl); }\n.text-7xl { font-size: var(--font-size-7xl); }\n.text-8xl { font-size: var(--font-size-8xl); }\n.text-9xl { font-size: var(--font-size-9xl); }\n\n/* Font Weights (Extended) */\n.font-thin { font-weight: var(--font-weight-thin); }\n.font-extralight { font-weight: var(--font-weight-extralight); }\n.font-extrabold { font-weight: var(--font-weight-extrabold); }\n.font-black { font-weight: var(--font-weight-black); }\n\n/* Line Heights */\n.leading-none { line-height: var(--line-height-none); }\n.leading-tight { line-height: var(--line-height-tight); }\n.leading-snug { line-height: var(--line-height-snug); }\n.leading-normal { line-height: var(--line-height-normal); }\n.leading-relaxed { line-height: var(--line-height-relaxed); }\n.leading-loose { line-height: var(--line-height-loose); }\n\n/* Letter Spacing */\n.tracking-tighter { letter-spacing: var(--letter-spacing-tighter); }\n.tracking-tight { letter-spacing: var(--letter-spacing-tight); }\n.tracking-normal { letter-spacing: var(--letter-spacing-normal); }\n.tracking-wide { letter-spacing: var(--letter-spacing-wide); }\n.tracking-wider { letter-spacing: var(--letter-spacing-wider); }\n.tracking-widest { letter-spacing: var(--letter-spacing-widest); }\n\n/* Text Colors (Extended) */\n.text-success { color: var(--color-success); }\n.text-warning { color: var(--color-warning); }\n.text-error { color: var(--color-error); }\n.text-info { color: var(--color-info); }\n.text-white { color: white; }\n.text-black { color: black; }\n\n/* Text Utilities */\n.text-uppercase { text-transform: uppercase; }\n.text-lowercase { text-transform: lowercase; }\n.text-capitalize { text-transform: capitalize; }\n.text-truncate {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.text-ellipsis {\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.text-clip {\n  text-overflow: clip;\n}\n\n/* ==========================================================================\n   Spacing Utilities (Extended)\n   ========================================================================== */\n\n/* Margin Utilities */\n.m-1 { margin: var(--spacing-1); }\n.m-2 { margin: var(--spacing-2); }\n.m-3 { margin: var(--spacing-3); }\n.m-4 { margin: var(--spacing-4); }\n.m-5 { margin: var(--spacing-5); }\n.m-6 { margin: var(--spacing-6); }\n.m-8 { margin: var(--spacing-8); }\n.m-10 { margin: var(--spacing-10); }\n.m-12 { margin: var(--spacing-12); }\n.m-16 { margin: var(--spacing-16); }\n.m-20 { margin: var(--spacing-20); }\n.m-24 { margin: var(--spacing-24); }\n.m-32 { margin: var(--spacing-32); }\n\n/* Margin X-axis */\n.mx-1 { margin-left: var(--spacing-1); margin-right: var(--spacing-1); }\n.mx-2 { margin-left: var(--spacing-2); margin-right: var(--spacing-2); }\n.mx-3 { margin-left: var(--spacing-3); margin-right: var(--spacing-3); }\n.mx-4 { margin-left: var(--spacing-4); margin-right: var(--spacing-4); }\n.mx-6 { margin-left: var(--spacing-6); margin-right: var(--spacing-6); }\n.mx-8 { margin-left: var(--spacing-8); margin-right: var(--spacing-8); }\n\n/* Margin Y-axis */\n.my-1 { margin-top: var(--spacing-1); margin-bottom: var(--spacing-1); }\n.my-2 { margin-top: var(--spacing-2); margin-bottom: var(--spacing-2); }\n.my-3 { margin-top: var(--spacing-3); margin-bottom: var(--spacing-3); }\n.my-4 { margin-top: var(--spacing-4); margin-bottom: var(--spacing-4); }\n.my-6 { margin-top: var(--spacing-6); margin-bottom: var(--spacing-6); }\n.my-8 { margin-top: var(--spacing-8); margin-bottom: var(--spacing-8); }\n.my-12 { margin-top: var(--spacing-12); margin-bottom: var(--spacing-12); }\n.my-16 { margin-top: var(--spacing-16); margin-bottom: var(--spacing-16); }\n.my-20 { margin-top: var(--spacing-20); margin-bottom: var(--spacing-20); }\n\n/* Margin Top */\n.mt-1 { margin-top: var(--spacing-1); }\n.mt-2 { margin-top: var(--spacing-2); }\n.mt-3 { margin-top: var(--spacing-3); }\n.mt-4 { margin-top: var(--spacing-4); }\n.mt-6 { margin-top: var(--spacing-6); }\n.mt-8 { margin-top: var(--spacing-8); }\n.mt-12 { margin-top: var(--spacing-12); }\n.mt-16 { margin-top: var(--spacing-16); }\n.mt-20 { margin-top: var(--spacing-20); }\n\n/* Margin Bottom */\n.mb-1 { margin-bottom: var(--spacing-1); }\n.mb-2 { margin-bottom: var(--spacing-2); }\n.mb-3 { margin-bottom: var(--spacing-3); }\n.mb-4 { margin-bottom: var(--spacing-4); }\n.mb-6 { margin-bottom: var(--spacing-6); }\n.mb-8 { margin-bottom: var(--spacing-8); }\n.mb-12 { margin-bottom: var(--spacing-12); }\n.mb-16 { margin-bottom: var(--spacing-16); }\n.mb-20 { margin-bottom: var(--spacing-20); }\n\n/* Padding Utilities (Extended) */\n.p-1 { padding: var(--spacing-1); }\n.p-2 { padding: var(--spacing-2); }\n.p-3 { padding: var(--spacing-3); }\n.p-5 { padding: var(--spacing-5); }\n.p-10 { padding: var(--spacing-10); }\n.p-12 { padding: var(--spacing-12); }\n.p-16 { padding: var(--spacing-16); }\n.p-20 { padding: var(--spacing-20); }\n.p-24 { padding: var(--spacing-24); }\n\n/* Padding X-axis */\n.px-1 { padding-left: var(--spacing-1); padding-right: var(--spacing-1); }\n.px-2 { padding-left: var(--spacing-2); padding-right: var(--spacing-2); }\n.px-3 { padding-left: var(--spacing-3); padding-right: var(--spacing-3); }\n.px-5 { padding-left: var(--spacing-5); padding-right: var(--spacing-5); }\n.px-6 { padding-left: var(--spacing-6); padding-right: var(--spacing-6); }\n.px-8 { padding-left: var(--spacing-8); padding-right: var(--spacing-8); }\n.px-12 { padding-left: var(--spacing-12); padding-right: var(--spacing-12); }\n\n/* Padding Y-axis */\n.py-1 { padding-top: var(--spacing-1); padding-bottom: var(--spacing-1); }\n.py-2 { padding-top: var(--spacing-2); padding-bottom: var(--spacing-2); }\n.py-3 { padding-top: var(--spacing-3); padding-bottom: var(--spacing-3); }\n.py-5 { padding-top: var(--spacing-5); padding-bottom: var(--spacing-5); }\n.py-6 { padding-top: var(--spacing-6); padding-bottom: var(--spacing-6); }\n.py-8 { padding-top: var(--spacing-8); padding-bottom: var(--spacing-8); }\n.py-12 { padding-top: var(--spacing-12); padding-bottom: var(--spacing-12); }\n.py-16 { padding-top: var(--spacing-16); padding-bottom: var(--spacing-16); }\n.py-20 { padding-top: var(--spacing-20); padding-bottom: var(--spacing-20); }\n\n/* ==========================================================================\n   Background and Border Utilities\n   ========================================================================== */\n\n/* Background Colors */\n.bg-primary { background-color: var(--color-primary); }\n.bg-secondary { background-color: var(--color-secondary); }\n.bg-success { background-color: var(--color-success); }\n.bg-warning { background-color: var(--color-warning); }\n.bg-error { background-color: var(--color-error); }\n.bg-info { background-color: var(--color-info); }\n.bg-surface { background-color: var(--color-surface); }\n.bg-surface-elevated { background-color: var(--color-surface-elevated); }\n.bg-white { background-color: white; }\n.bg-black { background-color: black; }\n.bg-transparent { background-color: transparent; }\n\n/* Background Gradients */\n.bg-gradient-primary {\n  background: linear-gradient(135deg, var(--color-primary) 0%, var(--color-primary-light) 100%);\n}\n\n.bg-gradient-secondary {\n  background: linear-gradient(135deg, var(--color-secondary) 0%, var(--color-secondary-light) 100%);\n}\n\n.bg-gradient-to-r {\n  background: linear-gradient(to right, var(--color-primary), var(--color-secondary));\n}\n\n.bg-gradient-to-b {\n  background: linear-gradient(to bottom, var(--color-primary), var(--color-primary-dark));\n}\n\n/* Border Utilities */\n.border { border: var(--border-width-1) solid var(--color-border); }\n.border-2 { border: var(--border-width-2) solid var(--color-border); }\n.border-4 { border: var(--border-width-4) solid var(--color-border); }\n.border-0 { border: 0; }\n\n.border-t { border-top: var(--border-width-1) solid var(--color-border); }\n.border-r { border-right: var(--border-width-1) solid var(--color-border); }\n.border-b { border-bottom: var(--border-width-1) solid var(--color-border); }\n.border-l { border-left: var(--border-width-1) solid var(--color-border); }\n\n/* Border Colors */\n.border-primary { border-color: var(--color-primary); }\n.border-secondary { border-color: var(--color-secondary); }\n.border-success { border-color: var(--color-success); }\n.border-warning { border-color: var(--color-warning); }\n.border-error { border-color: var(--color-error); }\n.border-transparent { border-color: transparent; }\n\n/* Border Radius (Extended) */\n.rounded-none { border-radius: var(--radius-none); }\n.rounded-sm { border-radius: var(--radius-sm); }\n.rounded-2xl { border-radius: var(--radius-2xl); }\n.rounded-3xl { border-radius: var(--radius-3xl); }\n\n.rounded-t { border-top-left-radius: var(--radius-base); border-top-right-radius: var(--radius-base); }\n.rounded-r { border-top-right-radius: var(--radius-base); border-bottom-right-radius: var(--radius-base); }\n.rounded-b { border-bottom-left-radius: var(--radius-base); border-bottom-right-radius: var(--radius-base); }\n.rounded-l { border-top-left-radius: var(--radius-base); border-bottom-left-radius: var(--radius-base); }\n\n/* ==========================================================================\n   Flexbox and Grid Utilities (Extended)\n   ========================================================================== */\n\n/* Flex Grow/Shrink */\n.flex-grow { flex-grow: 1; }\n.flex-grow-0 { flex-grow: 0; }\n.flex-shrink { flex-shrink: 1; }\n.flex-shrink-0 { flex-shrink: 0; }\n\n/* Align Self */\n.self-auto { align-self: auto; }\n.self-start { align-self: flex-start; }\n.self-center { align-self: center; }\n.self-end { align-self: flex-end; }\n.self-stretch { align-self: stretch; }\n\n/* Order */\n.order-1 { order: 1; }\n.order-2 { order: 2; }\n.order-3 { order: 3; }\n.order-first { order: -9999; }\n.order-last { order: 9999; }\n.order-none { order: 0; }\n\n/* Grid Utilities (Extended) */\n.grid-cols-5 { grid-template-columns: repeat(5, minmax(0, 1fr)); }\n.grid-cols-7 { grid-template-columns: repeat(7, minmax(0, 1fr)); }\n.grid-cols-8 { grid-template-columns: repeat(8, minmax(0, 1fr)); }\n.grid-cols-9 { grid-template-columns: repeat(9, minmax(0, 1fr)); }\n.grid-cols-10 { grid-template-columns: repeat(10, minmax(0, 1fr)); }\n.grid-cols-11 { grid-template-columns: repeat(11, minmax(0, 1fr)); }\n\n/* Grid Column Span */\n.col-span-1 { grid-column: span 1 / span 1; }\n.col-span-2 { grid-column: span 2 / span 2; }\n.col-span-3 { grid-column: span 3 / span 3; }\n.col-span-4 { grid-column: span 4 / span 4; }\n.col-span-5 { grid-column: span 5 / span 5; }\n.col-span-6 { grid-column: span 6 / span 6; }\n.col-span-full { grid-column: 1 / -1; }\n\n/* Grid Row Span */\n.row-span-1 { grid-row: span 1 / span 1; }\n.row-span-2 { grid-row: span 2 / span 2; }\n.row-span-3 { grid-row: span 3 / span 3; }\n.row-span-4 { grid-row: span 4 / span 4; }\n.row-span-full { grid-row: 1 / -1; }\n\n/* Gap Utilities (Extended) */\n.gap-0 { gap: 0; }\n.gap-0-5 { gap: var(--spacing-0-5); }\n.gap-1-5 { gap: var(--spacing-1-5); }\n.gap-5 { gap: var(--spacing-5); }\n.gap-10 { gap: var(--spacing-10); }\n.gap-12 { gap: var(--spacing-12); }\n.gap-16 { gap: var(--spacing-16); }\n.gap-20 { gap: var(--spacing-20); }\n\n.gap-x-1 { column-gap: var(--spacing-1); }\n.gap-x-2 { column-gap: var(--spacing-2); }\n.gap-x-4 { column-gap: var(--spacing-4); }\n.gap-x-6 { column-gap: var(--spacing-6); }\n.gap-x-8 { column-gap: var(--spacing-8); }\n\n.gap-y-1 { row-gap: var(--spacing-1); }\n.gap-y-2 { row-gap: var(--spacing-2); }\n.gap-y-4 { row-gap: var(--spacing-4); }\n.gap-y-6 { row-gap: var(--spacing-6); }\n.gap-y-8 { row-gap: var(--spacing-8); }\n\n/* ==========================================================================\n   Width and Height Utilities\n   ========================================================================== */\n\n/* Width */\n.w-auto { width: auto; }\n.w-full { width: 100%; }\n.w-screen { width: 100vw; }\n.w-min { width: min-content; }\n.w-max { width: max-content; }\n.w-fit { width: fit-content; }\n\n.w-1\\/2 { width: 50%; }\n.w-1\\/3 { width: 33.333333%; }\n.w-2\\/3 { width: 66.666667%; }\n.w-1\\/4 { width: 25%; }\n.w-3\\/4 { width: 75%; }\n.w-1\\/5 { width: 20%; }\n.w-2\\/5 { width: 40%; }\n.w-3\\/5 { width: 60%; }\n.w-4\\/5 { width: 80%; }\n\n/* Height */\n.h-auto { height: auto; }\n.h-full { height: 100%; }\n.h-screen { height: 100vh; }\n.h-min { height: min-content; }\n.h-max { height: max-content; }\n.h-fit { height: fit-content; }\n\n.h-1\\/2 { height: 50%; }\n.h-1\\/3 { height: 33.333333%; }\n.h-2\\/3 { height: 66.666667%; }\n.h-1\\/4 { height: 25%; }\n.h-3\\/4 { height: 75%; }\n\n/* Min/Max Width */\n.min-w-0 { min-width: 0px; }\n.min-w-full { min-width: 100%; }\n.min-w-min { min-width: min-content; }\n.min-w-max { min-width: max-content; }\n\n.max-w-none { max-width: none; }\n.max-w-xs { max-width: 20rem; }\n.max-w-sm { max-width: 24rem; }\n.max-w-md { max-width: 28rem; }\n.max-w-lg { max-width: 32rem; }\n.max-w-xl { max-width: 36rem; }\n.max-w-2xl { max-width: 42rem; }\n.max-w-3xl { max-width: 48rem; }\n.max-w-4xl { max-width: 56rem; }\n.max-w-5xl { max-width: 64rem; }\n.max-w-6xl { max-width: 72rem; }\n.max-w-7xl { max-width: 80rem; }\n.max-w-full { max-width: 100%; }\n.max-w-screen-sm { max-width: var(--breakpoint-sm); }\n.max-w-screen-md { max-width: var(--breakpoint-md); }\n.max-w-screen-lg { max-width: var(--breakpoint-lg); }\n.max-w-screen-xl { max-width: var(--breakpoint-xl); }\n\n/* Min/Max Height */\n.min-h-0 { min-height: 0px; }\n.min-h-full { min-height: 100%; }\n.min-h-screen { min-height: 100vh; }\n\n.max-h-full { max-height: 100%; }\n.max-h-screen { max-height: 100vh; }\n\n/* ==========================================================================\n   Animation and Transform Utilities\n   ========================================================================== */\n\n/* Transform */\n.transform { transform: translateX(var(--tw-translate-x, 0)) translateY(var(--tw-translate-y, 0)) rotate(var(--tw-rotate, 0)) skewX(var(--tw-skew-x, 0)) skewY(var(--tw-skew-y, 0)) scaleX(var(--tw-scale-x, 1)) scaleY(var(--tw-scale-y, 1)); }\n.transform-none { transform: none; }\n\n/* Scale */\n.scale-0 { transform: scale(0); }\n.scale-50 { transform: scale(0.5); }\n.scale-75 { transform: scale(0.75); }\n.scale-90 { transform: scale(0.9); }\n.scale-95 { transform: scale(0.95); }\n.scale-100 { transform: scale(1); }\n.scale-105 { transform: scale(1.05); }\n.scale-110 { transform: scale(1.1); }\n.scale-125 { transform: scale(1.25); }\n.scale-150 { transform: scale(1.5); }\n\n/* Rotate */\n.rotate-0 { transform: rotate(0deg); }\n.rotate-1 { transform: rotate(1deg); }\n.rotate-2 { transform: rotate(2deg); }\n.rotate-3 { transform: rotate(3deg); }\n.rotate-6 { transform: rotate(6deg); }\n.rotate-12 { transform: rotate(12deg); }\n.rotate-45 { transform: rotate(45deg); }\n.rotate-90 { transform: rotate(90deg); }\n.rotate-180 { transform: rotate(180deg); }\n\n/* Translate */\n.translate-x-0 { transform: translateX(0px); }\n.translate-x-1 { transform: translateX(var(--spacing-1)); }\n.translate-x-2 { transform: translateX(var(--spacing-2)); }\n.translate-x-4 { transform: translateX(var(--spacing-4)); }\n.translate-x-8 { transform: translateX(var(--spacing-8)); }\n\n.translate-y-0 { transform: translateY(0px); }\n.translate-y-1 { transform: translateY(var(--spacing-1)); }\n.translate-y-2 { transform: translateY(var(--spacing-2)); }\n.translate-y-4 { transform: translateY(var(--spacing-4)); }\n.translate-y-8 { transform: translateY(var(--spacing-8)); }\n\n/* Animation Classes */\n.animate-spin {\n  animation: spin 1s linear infinite;\n}\n\n.animate-ping {\n  animation: ping 1s cubic-bezier(0, 0, 0.2, 1) infinite;\n}\n\n.animate-pulse {\n  animation: pulse 2s cubic-bezier(0.4, 0, 0.6, 1) infinite;\n}\n\n.animate-bounce {\n  animation: bounce 1s infinite;\n}\n\n.animate-fade-in {\n  animation: fadeIn 0.5s ease-in-out;\n}\n\n.animate-slide-in-up {\n  animation: slideInUp 0.5s ease-out;\n}\n\n.animate-slide-in-down {\n  animation: slideInDown 0.5s ease-out;\n}\n\n.animate-slide-in-left {\n  animation: slideInLeft 0.5s ease-out;\n}\n\n.animate-slide-in-right {\n  animation: slideInRight 0.5s ease-out;\n}\n\n@keyframes ping {\n  75%, 100% {\n    transform: scale(2);\n    opacity: 0;\n  }\n}\n\n@keyframes pulse {\n  0%, 100% {\n    opacity: 1;\n  }\n  50% {\n    opacity: .5;\n  }\n}\n\n@keyframes bounce {\n  0%, 100% {\n    transform: translateY(-25%);\n    animation-timing-function: cubic-bezier(0.8, 0, 1, 1);\n  }\n  50% {\n    transform: translateY(0);\n    animation-timing-function: cubic-bezier(0, 0, 0.2, 1);\n  }\n}\n\n@keyframes fadeIn {\n  from {\n    opacity: 0;\n  }\n  to {\n    opacity: 1;\n  }\n}\n\n@keyframes slideInUp {\n  from {\n    transform: translateY(100%);\n    opacity: 0;\n  }\n  to {\n    transform: translateY(0);\n    opacity: 1;\n  }\n}\n\n@keyframes slideInDown {\n  from {\n    transform: translateY(-100%);\n    opacity: 0;\n  }\n  to {\n    transform: translateY(0);\n    opacity: 1;\n  }\n}\n\n@keyframes slideInLeft {\n  from {\n    transform: translateX(-100%);\n    opacity: 0;\n  }\n  to {\n    transform: translateX(0);\n    opacity: 1;\n  }\n}\n\n@keyframes slideInRight {\n  from {\n    transform: translateX(100%);\n    opacity: 0;\n  }\n  to {\n    transform: translateX(0);\n    opacity: 1;\n  }\n}\n\n/* ==========================================================================\n   Component-Specific Styles\n   ========================================================================== */\n\n/* Hero Section */\n.hero {\n  background: linear-gradient(135deg, var(--color-primary) 0%, var(--color-primary-light) 100%);\n  color: white;\n  padding: var(--spacing-32) 0 var(--spacing-20);\n  margin-top: 70px; /* Account for fixed navigation */\n  text-align: center;\n  position: relative;\n  overflow: hidden;\n}\n\n.hero::before {\n  content: '';\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: rgba(0, 0, 0, 0.1);\n  z-index: 1;\n}\n\n.hero-actions {\n  display: flex;\n  gap: var(--spacing-4);\n  justify-content: center;\n  flex-wrap: wrap;\n}\n\n/* Stats Section */\n.stats-section {\n  padding: var(--spacing-20) 0;\n  background-color: var(--color-surface);\n}\n\n.stats-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));\n  gap: var(--spacing-8);\n  text-align: center;\n}\n\n.stat-item {\n  padding: var(--spacing-6);\n  background: var(--color-surface-elevated);\n  border-radius: var(--radius-xl);\n  box-shadow: var(--shadow-sm);\n  transition: all var(--transition-base);\n}\n\n.stat-item:hover {\n  transform: translateY(-4px);\n  box-shadow: var(--shadow-md);\n}\n\n.stat-value {\n  font-size: var(--font-size-4xl);\n  font-weight: var(--font-weight-extrabold);\n  color: var(--color-primary);\n  margin-bottom: var(--spacing-2);\n  line-height: var(--line-height-none);\n}\n\n.stat-label {\n  font-size: var(--font-size-lg);\n  color: var(--color-text-secondary);\n  font-weight: var(--font-weight-medium);\n  text-transform: uppercase;\n  letter-spacing: var(--letter-spacing-wide);\n}\n\n/* Courses Overview */\n.courses-overview {\n  padding: var(--spacing-20) 0;\n}\n\n.section-title {\n  text-align: center;\n  font-size: var(--font-size-4xl);\n  margin-bottom: var(--spacing-12);\n  color: var(--color-text);\n  font-weight: var(--font-weight-extrabold);\n}\n\n.courses-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));\n  gap: var(--spacing-8);\n}\n\n/* Footer */\n.footer {\n  background-color: var(--color-primary);\n  color: white;\n  padding: var(--spacing-16) 0 var(--spacing-8);\n}\n\n.footer-content {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));\n  gap: var(--spacing-8);\n  margin-bottom: var(--spacing-8);\n}\n\n.footer-section h3,\n.footer-section h4 {\n  margin-bottom: var(--spacing-4);\n  color: white;\n  font-weight: var(--font-weight-bold);\n}\n\n.footer-section ul {\n  list-style: none;\n  padding: 0;\n}\n\n.footer-section ul li {\n  margin-bottom: var(--spacing-2);\n}\n\n.footer-section ul li a {\n  color: rgba(255, 255, 255, 0.8);\n  text-decoration: none;\n  transition: color var(--transition-fast);\n}\n\n.footer-section ul li a:hover {\n  color: white;\n  text-decoration: underline;\n}\n\n.footer-bottom {\n  text-align: center;\n  padding-top: var(--spacing-8);\n  border-top: 1px solid rgba(255, 255, 255, 0.2);\n  color: rgba(255, 255, 255, 0.8);\n}\n\n/* Loading Overlay */\n.loading-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background-color: rgba(0, 0, 0, 0.5);\n  backdrop-filter: blur(4px);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: var(--z-modal);\n}\n\n.loading-spinner {\n  width: 40px;\n  height: 40px;\n  border: 4px solid var(--color-border);\n  border-top: 4px solid var(--color-primary);\n  border-radius: 50%;\n  animation: spin 1s linear infinite;\n}\n\n/* Toast Notifications */\n.toast {\n  position: fixed;\n  top: var(--spacing-4);\n  right: var(--spacing-4);\n  background-color: var(--color-surface-elevated);\n  color: var(--color-text);\n  padding: var(--spacing-4) var(--spacing-6);\n  border-radius: var(--radius-lg);\n  box-shadow: var(--shadow-lg);\n  border: 1px solid var(--color-border);\n  z-index: var(--z-toast);\n  animation: slideInRight 0.3s ease-out;\n  max-width: 400px;\n  min-width: 300px;\n}\n\n.toast.success {\n  border-left: 4px solid var(--color-success);\n}\n\n.toast.error {\n  border-left: 4px solid var(--color-error);\n}\n\n.toast.warning {\n  border-left: 4px solid var(--color-warning);\n}\n\n.toast.info {\n  border-left: 4px solid var(--color-info);\n}\n\n/* Form Styles */\n.form-group {\n  margin-bottom: var(--spacing-4);\n}\n\n.form-label {\n  display: block;\n  margin-bottom: var(--spacing-2);\n  font-weight: var(--font-weight-medium);\n  color: var(--color-text);\n}\n\n.form-input {\n  width: 100%;\n  padding: var(--spacing-3) var(--spacing-4);\n  border: 1px solid var(--color-border);\n  border-radius: var(--radius-md);\n  background-color: var(--color-surface);\n  color: var(--color-text);\n  font-size: var(--font-size-base);\n  transition: all var(--transition-fast);\n}\n\n.form-input:focus {\n  outline: none;\n  border-color: var(--color-primary);\n  box-shadow: 0 0 0 3px rgba(var(--color-primary-rgb), 0.1);\n}\n\n.form-input.error {\n  border-color: var(--color-error);\n}\n\n.form-input.success {\n  border-color: var(--color-success);\n}\n\n.form-error {\n  color: var(--color-error);\n  font-size: var(--font-size-sm);\n  margin-top: var(--spacing-1);\n  display: flex;\n  align-items: center;\n  gap: var(--spacing-1);\n}\n\n.form-success {\n  color: var(--color-success);\n  font-size: var(--font-size-sm);\n  margin-top: var(--spacing-1);\n  display: flex;\n  align-items: center;\n  gap: var(--spacing-1);\n}\n\n/* Button Sizes */\n.btn-xs {\n  padding: var(--spacing-1) var(--spacing-2);\n  font-size: var(--font-size-xs);\n}\n\n.btn-sm {\n  padding: var(--spacing-2) var(--spacing-4);\n  font-size: var(--font-size-sm);\n}\n\n.btn-lg {\n  padding: var(--spacing-4) var(--spacing-8);\n  font-size: var(--font-size-lg);\n}\n\n.btn-xl {\n  padding: var(--spacing-5) var(--spacing-10);\n  font-size: var(--font-size-xl);\n}\n\n/* Card Component */\n.card {\n  background-color: var(--color-surface);\n  border: 1px solid var(--color-border);\n  border-radius: var(--radius-lg);\n  box-shadow: var(--shadow-sm);\n  overflow: hidden;\n  transition: all var(--transition-base);\n}\n\n.card:hover {\n  box-shadow: var(--shadow-md);\n  transform: translateY(-2px);\n}\n\n.card-header {\n  padding: var(--spacing-6);\n  border-bottom: 1px solid var(--color-border);\n  background-color: var(--color-surface-elevated);\n}\n\n.card-body {\n  padding: var(--spacing-6);\n}\n\n.card-footer {\n  padding: var(--spacing-6);\n  border-top: 1px solid var(--color-border);\n  background-color: var(--color-surface-elevated);\n}\n\n/* Badge Component */\n.badge {\n  display: inline-flex;\n  align-items: center;\n  padding: var(--spacing-1) var(--spacing-2);\n  font-size: var(--font-size-xs);\n  font-weight: var(--font-weight-medium);\n  border-radius: var(--radius-full);\n  text-transform: uppercase;\n  letter-spacing: var(--letter-spacing-wide);\n}\n\n.badge-primary {\n  background-color: var(--color-primary);\n  color: white;\n}\n\n.badge-secondary {\n  background-color: var(--color-secondary);\n  color: white;\n}\n\n.badge-success {\n  background-color: var(--color-success);\n  color: white;\n}\n\n.badge-warning {\n  background-color: var(--color-warning);\n  color: white;\n}\n\n.badge-error {\n  background-color: var(--color-error);\n  color: white;\n}\n\n.badge-outline {\n  background-color: transparent;\n  border: 1px solid var(--color-border);\n  color: var(--color-text);\n}\n\n/* ==========================================================================\n   Responsive Design Utilities\n   ========================================================================== */\n\n/* Mobile First Responsive Utilities */\n@media (min-width: 475px) {\n  .xs\\:block { display: block; }\n  .xs\\:hidden { display: none; }\n  .xs\\:flex { display: flex; }\n  .xs\\:grid { display: grid; }\n  .xs\\:text-center { text-align: center; }\n  .xs\\:text-left { text-align: left; }\n}\n\n@media (min-width: 640px) {\n  .sm\\:block { display: block; }\n  .sm\\:hidden { display: none; }\n  .sm\\:flex { display: flex; }\n  .sm\\:grid { display: grid; }\n  .sm\\:grid-cols-2 { grid-template-columns: repeat(2, minmax(0, 1fr)); }\n  .sm\\:grid-cols-3 { grid-template-columns: repeat(3, minmax(0, 1fr)); }\n  .sm\\:flex-row { flex-direction: row; }\n  .sm\\:flex-col { flex-direction: column; }\n  .sm\\:text-left { text-align: left; }\n  .sm\\:text-center { text-align: center; }\n  .sm\\:text-right { text-align: right; }\n  .sm\\:p-6 { padding: var(--spacing-6); }\n  .sm\\:px-6 { padding-left: var(--spacing-6); padding-right: var(--spacing-6); }\n  .sm\\:py-8 { padding-top: var(--spacing-8); padding-bottom: var(--spacing-8); }\n}\n\n@media (min-width: 768px) {\n  .md\\:block { display: block; }\n  .md\\:hidden { display: none; }\n  .md\\:flex { display: flex; }\n  .md\\:grid { display: grid; }\n  .md\\:grid-cols-2 { grid-template-columns: repeat(2, minmax(0, 1fr)); }\n  .md\\:grid-cols-3 { grid-template-columns: repeat(3, minmax(0, 1fr)); }\n  .md\\:grid-cols-4 { grid-template-columns: repeat(4, minmax(0, 1fr)); }\n  .md\\:flex-row { flex-direction: row; }\n  .md\\:flex-col { flex-direction: column; }\n  .md\\:text-left { text-align: left; }\n  .md\\:text-center { text-align: center; }\n  .md\\:text-right { text-align: right; }\n  .md\\:text-lg { font-size: var(--font-size-lg); }\n  .md\\:text-xl { font-size: var(--font-size-xl); }\n  .md\\:text-2xl { font-size: var(--font-size-2xl); }\n  .md\\:text-3xl { font-size: var(--font-size-3xl); }\n  .md\\:p-8 { padding: var(--spacing-8); }\n  .md\\:px-8 { padding-left: var(--spacing-8); padding-right: var(--spacing-8); }\n  .md\\:py-12 { padding-top: var(--spacing-12); padding-bottom: var(--spacing-12); }\n}\n\n@media (min-width: 1024px) {\n  .lg\\:block { display: block; }\n  .lg\\:hidden { display: none; }\n  .lg\\:flex { display: flex; }\n  .lg\\:grid { display: grid; }\n  .lg\\:grid-cols-3 { grid-template-columns: repeat(3, minmax(0, 1fr)); }\n  .lg\\:grid-cols-4 { grid-template-columns: repeat(4, minmax(0, 1fr)); }\n  .lg\\:grid-cols-5 { grid-template-columns: repeat(5, minmax(0, 1fr)); }\n  .lg\\:grid-cols-6 { grid-template-columns: repeat(6, minmax(0, 1fr)); }\n  .lg\\:flex-row { flex-direction: row; }\n  .lg\\:flex-col { flex-direction: column; }\n  .lg\\:text-left { text-align: left; }\n  .lg\\:text-center { text-align: center; }\n  .lg\\:text-right { text-align: right; }\n  .lg\\:text-xl { font-size: var(--font-size-xl); }\n  .lg\\:text-2xl { font-size: var(--font-size-2xl); }\n  .lg\\:text-3xl { font-size: var(--font-size-3xl); }\n  .lg\\:text-4xl { font-size: var(--font-size-4xl); }\n  .lg\\:p-12 { padding: var(--spacing-12); }\n  .lg\\:px-12 { padding-left: var(--spacing-12); padding-right: var(--spacing-12); }\n  .lg\\:py-16 { padding-top: var(--spacing-16); padding-bottom: var(--spacing-16); }\n}\n\n@media (min-width: 1280px) {\n  .xl\\:block { display: block; }\n  .xl\\:hidden { display: none; }\n  .xl\\:grid-cols-4 { grid-template-columns: repeat(4, minmax(0, 1fr)); }\n  .xl\\:grid-cols-5 { grid-template-columns: repeat(5, minmax(0, 1fr)); }\n  .xl\\:grid-cols-6 { grid-template-columns: repeat(6, minmax(0, 1fr)); }\n  .xl\\:text-2xl { font-size: var(--font-size-2xl); }\n  .xl\\:text-3xl { font-size: var(--font-size-3xl); }\n  .xl\\:text-4xl { font-size: var(--font-size-4xl); }\n  .xl\\:text-5xl { font-size: var(--font-size-5xl); }\n}\n\n@media (min-width: 1536px) {\n  .2xl\\:block { display: block; }\n  .2xl\\:hidden { display: none; }\n  .2xl\\:grid-cols-5 { grid-template-columns: repeat(5, minmax(0, 1fr)); }\n  .2xl\\:grid-cols-6 { grid-template-columns: repeat(6, minmax(0, 1fr)); }\n  .2xl\\:text-3xl { font-size: var(--font-size-3xl); }\n  .2xl\\:text-4xl { font-size: var(--font-size-4xl); }\n  .2xl\\:text-5xl { font-size: var(--font-size-5xl); }\n  .2xl\\:text-6xl { font-size: var(--font-size-6xl); }\n}\n\n/* ==========================================================================\n   Mobile Responsive Adjustments\n   ========================================================================== */\n\n@media (max-width: 768px) {\n  .hero {\n    padding: var(--spacing-20) 0 var(--spacing-16);\n  }\n  \n  .hero-title {\n    font-size: var(--font-size-3xl);\n  }\n  \n  .hero-subtitle {\n    font-size: var(--font-size-lg);\n  }\n  \n  .hero-actions {\n    flex-direction: column;\n    align-items: center;\n  }\n  \n  .stats-grid {\n    grid-template-columns: repeat(2, 1fr);\n    gap: var(--spacing-4);\n  }\n  \n  .courses-grid {\n    grid-template-columns: 1fr;\n  }\n  \n  .section-title {\n    font-size: var(--font-size-3xl);\n  }\n  \n  .toast {\n    left: var(--spacing-4);\n    right: var(--spacing-4);\n    max-width: none;\n  }\n}\n\n@media (max-width: 480px) {\n  .stats-grid {\n    grid-template-columns: 1fr;\n  }\n  \n  .stat-value {\n    font-size: var(--font-size-3xl);\n  }\n  \n  .hero-title {\n    font-size: var(--font-size-2xl);\n  }\n  \n  .section-title {\n    font-size: var(--font-size-2xl);\n  }\n  \n\n}\n\n/* ==========================================================================\n   Print Styles\n   ========================================================================== */\n\n@media print {\n  .no-print {\n    display: none !important;\n  }\n  \n  .hero,\n  .navigation,\n  .footer,\n  .toast,\n  .loading-overlay {\n    display: none !important;\n  }\n  \n  * {\n    background: white !important;\n    color: black !important;\n    box-shadow: none !important;\n  }\n  \n  a {\n    text-decoration: underline !important;\n  }\n  \n  .container {\n    max-width: none !important;\n    padding: 0 !important;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
